export default "__VITE_ASSET__B$jiToxX__"